const DataAbout = {
  section: [
    {
      title: [
        {
          text: 'Tentang Kami',
        },
      ],
      content: [
        {
          paragraph: [
            [
              {
                text: 'Kami menyediakan ',
              },
              {
                text: 'tools',
                type: 'italic',
              },
              {
                text: ' dan literatur untuk kamu yang ingin belajar seputar asuransi. Di sini, kamu bisa memperdalam pengetahuan asuransi serta bereksperimen dengan premi neto asuransi (jiwa).',
              },
            ],
          ],
        },
      ],
    },
  ],
};

export default DataAbout;
